import React from "react";
import {
  useHierarchicalMenu,
  UseHierarchicalMenuProps,
} from "react-instantsearch";
import { isModifierClick } from "../utils/IsModifierClick";
import { translate } from "../../../Services/translation";
import { HierarchicalListProps } from "./types/HierarchicalListProps";

const CustomHierarchicalMenu = (props: UseHierarchicalMenuProps) => {
  const {
    items,
    refine,
    canToggleShowMore,
    toggleShowMore,
    isShowingMore,
    createURL,
  } = useHierarchicalMenu(props);

  return (
    <div className="algolia-hierarchical-menu">
      <HierarchicalList
        items={items}
        onNavigate={refine}
        createURL={createURL}
      />
      {props.showMore && (
        <button
          disabled={!canToggleShowMore}
          onClick={toggleShowMore}
          className="algolia-hierarchical-menu__more-button"
        >
          {isShowingMore
            ? translate("algolia.filters.show-less")
            : translate("algolia.filters.show-more")}
        </button>
      )}
    </div>
  );
};

function HierarchicalList({
  items,
  createURL,
  onNavigate,
}: HierarchicalListProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <ul className="algolia-hierarchical-menu__list">
      {items.map((item) => (
        <li
          key={item.value}
          className={`algolia-hierarchical-menu__item ${
            item.isRefined ? "algolia-hierarchical-menu__item--checked" : ""
          }`}
        >
          <a
            className="algolia-hierarchical-menu__item__link"
            href={createURL(item.value)}
            onClick={(event) => {
              if (isModifierClick(event)) {
                return;
              }
              event.preventDefault();

              onNavigate(item.value);
            }}
          >
            <span className="algolia-hierarchical-menu__item__label">
              {item.label}
            </span>
            <span className="algolia-hierarchical-menu__item__count">
              {item.count}
            </span>
          </a>
          {item.data && (
            <HierarchicalList
              items={item.data}
              onNavigate={onNavigate}
              createURL={createURL}
            />
          )}
        </li>
      ))}
    </ul>
  );
}

export default CustomHierarchicalMenu;
